// src/styles/themeprovider.js
import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import theme from './Theme';

// Create a wrapper component that includes the ThemeProvider
const CustomThemeProvider = ({ children }) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default CustomThemeProvider;
